import React, { PropTypes, Component } from 'react'
import Logo from './Logo'
import styled from 'styled-components'

const Modal = styled.a`
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(12, 24, 27, 0.9);
  transition: opacity 0.5s;
  vertical-align: middle;
  cursor: pointer;
`

class Introduction extends Component {
  render () {
    return (
      <Modal onClick={this.props.handleStart} ref='modal'>
        <Logo />
      </Modal>
    )
  }
}

Introduction.propTypes = {
  handleStart: PropTypes.func
}

export default Introduction



/** WEBPACK FOOTER **
 ** ./src/components/Introduction.js
 **/